/**
 * 모델
 * @window w_tb_e035w_05
 * @category 월점검 비통채크현황
 */
export class MonthEmergencyCallRecentModel {
  /**
   *
   *
   */
  readonly actcd: string;

  /**
   *
   *
   */
  readonly actnm: string;

  /**
   *
   *
   */
  readonly cnt: string;

  /**
   *
   *
   */
  readonly custcd: string;

  /**
   *
   *
   */
  readonly divicd: string;

  /**
   *
   *
   */
  readonly divinm: string;

  /**
   *
   *
   */
  readonly noreply: string;

  /**
   *
   *
   */
  readonly perid: string;

  /**
   *
   *
   */
  readonly pernm: string;

  /**
   *
   *
   */
  readonly quality: string;

  /**
   *
   *
   */
  readonly result: string;

  /**
   *
   *
   */
  readonly resultnm: string;

  /**
   *
   *
   */
  readonly seq: string;

  /**
   *
   *
   */
  readonly seq_ai: string;

  /**
   *
   *
   */
  readonly spjangcd: string;

  /**
   *
   *
   */
  readonly susincnt: string;

  /**
   *
   *
   */
  readonly susinresult: string;

  /**
   *
   *
   */
  readonly tel: string;

  /**
   *
   *
   */
  readonly telcomp: string;

  constructor(data: any) {
    this.actcd = data.actcd || '';
    this.actnm = data.actnm || '';
    this.cnt = data.cnt || '';
    this.custcd = data.custcd || '';
    this.divicd = data.divicd || '';
    this.divinm = data.divinm || '';
    this.noreply = data.noreply || '';
    this.perid = data.perid || '';
    this.pernm = data.pernm || '';
    this.quality = data.quality || '';
    this.result = data.result || '';
    this.resultnm = data.resultnm || '';
    this.seq = data.seq || '';
    this.seq_ai = data.seq_ai || '';
    this.spjangcd = data.spjangcd || '';
    this.susincnt = data.susincnt || '';
    this.susinresult = data.susinresult || '';
    this.tel = data.tel || '';
    this.telcomp = data.telcomp || '';
  }
}
